/* Visor de fotos de producto · Jenny Calderón Shoes (complemento del zoom-dialog de Horizon)
   Escritorio: clic sobre la foto = zoom 2,2x que sigue el mouse; otro clic lo quita. Flechas y teclado pasan de foto.
   Móvil: se conserva el pellizco / doble toque del tema; solo se añade el contador. */
(function () {
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var ZOOM = 2.2;

  function setup(dialogEl) {
    if (dialogEl.dataset.jcZoom) return;
    var list = dialogEl.querySelector('.dialog-zoomed-gallery');
    if (!list) return;
    dialogEl.dataset.jcZoom = '1';
    var items = Array.prototype.slice.call(list.children);
    var zoomed = null;

    var counter = document.createElement('div');
    counter.className = 'jc-zoom-counter';
    dialogEl.appendChild(counter);

    function mkNav(cls, html, label) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'jc-zoom-nav ' + cls; b.innerHTML = html; b.setAttribute('aria-label', label);
      dialogEl.appendChild(b); return b;
    }
    var prev = mkNav('jc-zoom-nav--prev', '&#8249;', 'Foto anterior');
    var next = mkNav('jc-zoom-nav--next', '&#8250;', 'Foto siguiente');

    function index() {
      var top = dialogEl.scrollTop, best = 0, bd = Infinity;
      items.forEach(function (li, i) { var d = Math.abs(li.offsetTop - top); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function resetZoom() {
      if (!zoomed) return;
      zoomed.style.transform = ''; zoomed.style.transformOrigin = '';
      var li = zoomed.closest('li'); if (li) li.classList.remove('jc-zoomed');
      zoomed = null;
    }
    function origin(img, e) {
      var r = img.getBoundingClientRect();
      var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
      var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
      img.style.transformOrigin = x.toFixed(1) + '% ' + y.toFixed(1) + '%';
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      resetZoom();
      items[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function update() {
      var i = index();
      counter.textContent = (i + 1) + ' / ' + items.length;
      prev.hidden = i === 0; next.hidden = i === items.length - 1;
    }

    dialogEl.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    prev.addEventListener('click', function (e) { e.stopPropagation(); go(index() - 1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); go(index() + 1); });
    dialogEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(index() - 1); }
    });

    if (FINE) {
      // clic en la foto: zoom que sigue el mouse (y no cierra el diálogo, que es lo que hace el tema por defecto)
      // en la ventana (fase de captura) para adelantarse al delegado de Horizon, que cierra el diálogo al hacer clic
      window.addEventListener('click', function (e) {
        var img = e.target.closest ? e.target.closest('img.product-media__image') : null;
        if (!img || !list.contains(img) || !dialogEl.open) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (zoomed === img) { resetZoom(); return; }
        resetZoom(); origin(img, e);
        img.style.transform = 'scale(' + ZOOM + ')';
        var li = img.closest('li'); if (li) li.classList.add('jc-zoomed');
        zoomed = img;
      }, true);
      list.addEventListener('mousemove', function (e) {
        if (!zoomed) return;
        var li = zoomed.closest('li');
        if (li && li.contains(e.target)) origin(zoomed, e);
      }, true);
    }

    new MutationObserver(function () { if (!dialogEl.open) resetZoom(); else update(); })
      .observe(dialogEl, { attributes: true, attributeFilter: ['open'] });
    update();
  }

  function init() { document.querySelectorAll('zoom-dialog dialog').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
